import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=1891ddf2&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=1891ddf2&prod&scoped=true&lang=scss"
import style1 from "./ProductCard.vue?vue&type=style&index=1&id=1891ddf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1891ddf2",
  null
  
)

export default component.exports